import type { ScheduledEvent } from '../event-details';

export const buildWebplayerUrl = (scheduledEvent: ScheduledEvent): string => {
  /*
   * Private events have no public link: the backend returns the sentence "Event URL is hidden for
   * Private Events" in `webplayer_url`, which used to end up as the href.
   */
  if (scheduledEvent.hidden) {
    return '';
  }

  return scheduledEvent.webplayer_url ? String(scheduledEvent.webplayer_url) : '';
};
